import api from './api';

/**
 * @param {string} templateId
 * @param {{
 *  primary_targets: string[] | null
 *  secondary_targets: string[] | null
 * }} template
 */
export default async function updateAutomarkerTargetTemplate(templateId, template) {
    const { data } = await api.put(`target_templates/${templateId}`, template);

    return data;
}